import React, {useEffect, useCallback} from 'react';
import {isMobile} from 'react-device-detect';

export const usePart = ({parts, setPart, part}) => {
    useEffect(() => {
        window.addEventListener("scroll", onScroll);

        return () => window.removeEventListener("scroll", onScroll);
    }, [setPart, part, parts]);

    const onScroll = useCallback(() => {
        for (let i=2; i < parts.length; i++) {
            let offset = i===2 && isMobile ? 200 : i === 2 ? 600 : 0;
            let ref = parts[i];
            let scrollTop = window.scrollY;
            let top = ref.current.offsetTop - offset;
            let height = ref.current.offsetHeight;
            let bottom = top + height + offset;

            if (scrollTop >= top && scrollTop <= bottom) {
                setPart(i);
                return;
            } 
        }
        setPart(0);
    }, [setPart, part, parts]);
};
